export default __webpack_public_path__ + "static/image-financial-industry-page-main-v1-960x540.png";